export const BASE_URL_DEV = 'https://sensejupiter-dev.sensetime.com' // 开发
export const BASE_URL_TEST = 'https://sensejupiter-test.sensetime.com' // 测试
export const BASE_URL_PROD = 'https://sensejupiter.sensetime.com' // 生产
export const BASE_URL_STAGE = 'https://sensejupiter-stage.sensetime.com' // yu fa bu
let baseUrl = BASE_URL_DEV // BASE_URL_PROD
let isInit = false
const init = () => {
  if (process.env.REACT_APP_ENV === 'dev') {
    baseUrl = BASE_URL_DEV // BASE_URL_DEV
  } else if (process.env.REACT_APP_ENV === 'test') {
    baseUrl = BASE_URL_TEST
  } else if (process.env.REACT_APP_ENV === 'stage') {
    baseUrl = BASE_URL_STAGE
  } else if (process.env.REACT_APP_ENV === 'pro') {
    baseUrl = BASE_URL_PROD
  }
  isInit = true
}
export const getBaseUrl = () => {
  if (!isInit) {
    init()
  }
  return baseUrl
}
